export const DEFAULT_REGION_COLOR = '#999';

export const BASE_RADIUS = 500000;